import { createFileRoute } from '@tanstack/react-router';
import { AnnouncementsPage } from '@/pages/chain/AnnouncementsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	status: z.enum(['DRAFT', 'PUBLISHED', 'ARCHIVED']).optional(),
});

function ChainAnnouncementsPage() {
	return <AnnouncementsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/chain/announcements/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainContent.read'], redirectTo: '/dashboard' }),
	validateSearch: searchSchema,
	component: ChainAnnouncementsPage,
});
